import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiFactoryService} from '../../../../shared/services/api-factory.service';
import {CrudUploadsService} from '@shared/services/crud-uploads.service';
import {AbstractCrudEditComponent} from '@shared/library/crud-library/abstract-crud-edit.component';
import {AlertService, IAlert} from '@shared/services/alert.service';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {HttpEventType} from '@angular/common/http';

@Component({
  selector: 'app-uploads-edit',
  templateUrl: './uploads-edit.component.html',
  styleUrls: ['./uploads-edit.component.scss']
})
export class UploadsEditComponent extends AbstractCrudEditComponent {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    private uploadservice: CrudUploadsService,
    protected apifactory: ApiFactoryService,
    protected alertService: AlertService
  ) {
    super(activatedRoute, router, apifactory, uploadservice, alertService);

    this.fields = [
      {
        className: 'col-12',
        fieldGroup: [
          {
            key: 'global',
            type: 'checkbox',
            defaultValue: true,
            templateOptions: {
              label: 'Global'
            }
          }
        ]
      },
      {
        className: 'col-12',
        fieldGroup: [
          {
            key: 'appclient',
            type: 'ng-select',
            defaultValue: 0,
            templateOptions: {
              label: 'Client',
              required: true,
              closeOnSelect: true
            },
            hideExpression: 'model.global',
            hooks: {
              onInit: this.initAppClient
            }
          }
        ]
      },
      {
        className: 'col-12',
        fieldGroup: [
          {
            key: 'file',
            type: 'file',
            templateOptions: {label: 'File', required: true, percentDone: 0}
          }
        ]
      }
    ];

    this.createSectionTitle = 'Upload file';
    this.createButtonTitle = 'Upload';
    this.entityrooturl = '/admin/uploads';
  }

  /*
   * Form fields functions for dynamic values
   */
  initAppClient = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    const query = this.bffapi.getClients();
    query.subscribe((data) => {
      typedField.templateOptions.options = data.results;
    });
  }

  onSubmitHandler(): any {
    return () => {

      this.form.markAllAsTouched();
      if (this.form.valid) {
        this.isSubmitting = true;
        // verify file size: max 1024MB
        const fileSizeInMB = this.model.file[0].size / Math.pow(1024, 2);
        if (fileSizeInMB <= 1024) {
          this.fields[2].fieldGroup[0].templateOptions.percentDone = 1;
          this.uploadservice.createEntity(this.model).subscribe((response) => {
            if (response.type === HttpEventType.Response) {
              this.router.navigate([this.entityrooturl]).then(() => {
                this.isSubmitting = false;
                this.alertService.addAlert({
                  type: 'success',
                  title: 'File uploaded',
                  message: `New file has been uploaded successfully`,
                } as IAlert);
              });
            } else if (response.type === HttpEventType.UploadProgress) {
              this.fields[2].fieldGroup[0].templateOptions.percentDone = Math.round(100 * response.loaded / response.total);
              this.isSubmitting = false;
            }
          }, (error) => {
            this.fields[2].fieldGroup[0].templateOptions.percentDone = 0;
            this.alertService.addAlert({
              type: 'danger',
              title: 'File upload error',
              message: error.error.message,
            } as IAlert);
            this.isSubmitting = false;
          });

        } else {
          this.fields[2].fieldGroup[0].templateOptions.percentDone = 0;
          this.alertService.addAlert({
            type: 'danger',
            title: 'File upload error',
            message: 'Upload file is too large. Max size 1GB.',
          } as IAlert);
        }

      } else {
        // form not valid
        this.alertService.addAlert({
          type: 'danger',
          title: 'Error',
          message: `Incorrect inputs. Please review the form data.`,
        } as IAlert);
      }
    };
  }

}
